export const QA_NAME_LABEL_CREATION_MODAL = 'labelFormModal'
